import React from 'react';
import { isBrowser } from './dom.es.js';
var useEnhancedEffect = isBrowser ? React.useLayoutEffect : React.useEffect;
export { useEnhancedEffect };